import React, { useState, useEffect } from 'react'
import { Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { TextField } from '@material-ui/core';
import MenuItem from '@mui/material/MenuItem';
import CrearUsuario from '../../../components/buttons/crearUsuario';
import { Autocomplete } from '@material-ui/lab';
//Redux
import { connect } from 'react-redux';

// Componets
import Loading from '../../../components/modales/loadingModal';

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const crearUsuario = functionsHttpsCallable('usuarios_crearUsuario');
const listadoCentrosCostos = functionsHttpsCallable('ape_listadoCentroCostos');
const crearCentroCostos = functionsHttpsCallable('ape_crearFlujoAprobacion');


const mapStateToProps = state => ({
    usuarioActivo: state
})

let BodyCrearFlujo = (props) => {
    const [listado, setListado] = useState([]);
    const [centroCosto, setCentroCosto] = useState('');
    const [cod_1apr, setCod_1apr] = useState('');
    const [cod_1apr_cargo, setCod_1apr_cargo] = useState('');
    const [cod_1apr_email, setCod_1apr_email] = useState('');
    const [cod_1apr_name, setCod_1apr_name] = useState('');
    const [cod_2apr, setCod_2apr] = useState('');
    const [cod_2apr_cargo, setCod_2apr_cargo] = useState('');
    const [cod_2apr_email, setCod_2apr_email] = useState('');
    const [cod_2apr_name, setCod_2apr_name] = useState('');
    const [cod_3apr, setCod_3apr] = useState('');
    const [cod_3apr_cargo, setCod_3apr_cargo] = useState('');
    const [cod_3apr_email, setCod_3apr_email] = useState('');
    const [cod_3apr_name, setCod_3apr_name] = useState('');
    const [cod_4apr, setCod_4apr] = useState('');
    const [cod_4apr_cargo, setCod_4apr_cargo] = useState('');
    const [cod_4apr_email, setCod_4apr_email] = useState('');
    const [cod_4apr_name, setCod_4apr_name] = useState('');
    const [cod_recl, setCod_recl] = useState('');
    const [cod_recl_cargo, setCod_recl_cargo] = useState('');
    const [cod_recl_email, setCod_recl_email] = useState('');
    const [cod_recl_name, setCod_recl_name] = useState('');
    const [cod_cont, setCod_cont] = useState('');
    const [cod_cont_cargo, setCod_cont_cargo] = useState('');
    const [cod_cont_email, setCod_cont_email] = useState('');
    const [cod_cont_name, setCod_cont_name] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [tipo, setTipo] = useState('admin');
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));

    useEffect(() => {
        const getListadoCentroCostos = async () => {
            try {
                setIsLoading(true)
                const reqListado = await listadoCentrosCostos({
                    cod_empr: userData.codigoEmpresa,
                })
                setListado(reqListado.data.data)
                setIsLoading(false)
            }
            catch (error) {
                console.log(error)
            }
        }
        getListadoCentroCostos()
    }, []);

    const getIdCentroCosto = (centroCosto) => {
        if (centroCosto.includes('.1') || centroCosto.includes('.2') || centroCosto.includes('.3'))
            {
                return centroCosto.slice(0, 13)
            }
            else return centroCosto.slice(0, 11)
    }
    
    const crearFlujo = async () => {
        props.toggleLoading()
        let body = {
            cod_empr: userData.codigoEmpresa,
            idCentroCosto: getIdCentroCosto(centroCosto),
            tipo: tipo,
            nombreCentroCosto: centroCosto,
        }
        if (tipo === 'operativo') {
            body = {
                cod_1apr,
                cod_1apr_cargo,
                cod_1apr_email,
                cod_1apr_name,
                cod_2apr,
                cod_2apr_cargo,
                cod_2apr_email,
                cod_2apr_name,
                cod_3apr,
                cod_3apr_cargo,
                cod_3apr_email,
                cod_3apr_name,
                cod_4apr,
                cod_4apr_cargo,
                cod_4apr_email,
                cod_4apr_name,
                cod_recl,
                cod_recl_cargo,
                cod_recl_email,
                cod_recl_name,
                cod_cont,
                cod_cont_cargo,
                cod_cont_email,
                cod_cont_name,
                ...body}
        }
        try {
            const createUserReq = await crearCentroCostos(body);
            if (createUserReq.data.status === 'FLUJO_CREADO') {
                props.toggleLoading()
                props.toastSuccess('Flujo creado con exito!');
                props.toggle()
            }
            else if (createUserReq.data.status === 'FLUJO_EXISTENTE') {
                props.toggleLoading()
                props.toastError('El flujo para el centro de costo ya existe');
            }
            else {
                props.toggleLoading()
                props.toastError('Ocurrió un error');
            }
        }
        catch (error) {
            props.toggleLoading()
            props.toastError(`${error}`);
        }
}

const getValidacion = () => {
    const intialVal = (
        userData.codigoEmpresa !== undefined && userData.codigoEmpresa !== 0 && userData.codigoEmpresa !== '' &&
        centroCosto !== undefined && centroCosto !== 0 && centroCosto !== ''&&
        tipo !== undefined && tipo !== 0 && tipo !== '' 
    )
    const secondVal = (
        cod_1apr !== 0 && cod_1apr !== undefined && cod_1apr !== '' &&
        cod_1apr_cargo !== 0 && cod_1apr_cargo !== undefined && cod_1apr_cargo !== '' &&
        cod_1apr_email !== 0 && cod_1apr_email !== undefined && cod_1apr_email !== '' &&
        cod_1apr_name !== 0 && cod_1apr_name !== undefined && cod_1apr_name !== '' &&
        cod_2apr !== 0 && cod_2apr !== undefined && cod_2apr !== '' &&
        cod_2apr_cargo !== 0 && cod_2apr_cargo !== undefined && cod_2apr_cargo !== '' &&
        cod_2apr_email !== 0 && cod_2apr_email !== undefined && cod_2apr_email !== '' &&
        cod_2apr_name !== 0 && cod_2apr_name !== undefined && cod_2apr_name !== '' &&
        cod_3apr !== 0 && cod_3apr !== undefined && cod_3apr !== '' &&
        cod_3apr_cargo !== 0 && cod_3apr_cargo !== undefined && cod_3apr_cargo !== '' &&
        cod_3apr_email !== 0 && cod_3apr_email !== undefined && cod_3apr_email !== '' &&
        cod_3apr_name !== 0 && cod_3apr_name !== undefined && cod_3apr_name !== '' &&
        cod_4apr !== 0 && cod_4apr !== undefined && cod_4apr !== '' &&
        cod_4apr_cargo !== 0 && cod_4apr_cargo !== undefined && cod_4apr_cargo !== '' &&
        cod_4apr_email !== 0 && cod_4apr_email !== undefined && cod_4apr_email !== '' &&
        cod_4apr_name !== 0 && cod_4apr_name !== undefined && cod_4apr_name !== '' &&
        cod_recl !== 0 && cod_recl !== undefined && cod_recl !== '' &&
        cod_recl_cargo !== 0 && cod_recl_cargo !== undefined && cod_recl_cargo !== '' &&
        cod_recl_email !== 0 && cod_recl_email !== undefined && cod_recl_email !== '' &&
        cod_recl_name !== 0 && cod_recl_name !== undefined && cod_recl_name !== '' &&
        cod_cont !== 0 && cod_cont !== undefined && cod_cont !== '' &&
        cod_cont_cargo !== 0 && cod_cont_cargo !== undefined && cod_cont_cargo !== '' &&
        cod_cont_email !== 0 && cod_cont_email !== undefined && cod_cont_email !== '' &&
        cod_cont_name !== 0 && cod_cont_name !== undefined && cod_cont_name !== ''
    )
    return tipo === 'admin' ? intialVal : intialVal && secondVal
}
    if (isLoading) {
        return (
            <div className={"loading-area"}><Loading /></div>
        )
    }
    else return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='6' md='6' xs="12">
                        <TextField
                            variant='outlined'
                            required
                            select
                            autoComplete='off'
                            key={`key_tipo`}
                            id={`input_tipo`}
                            fullWidth
                            defaultValue={tipo}
                            label='Tipo de flujo'
                            margin="normal"
                            onChange={(e) => { setTipo(e.target.value) }}
                        >
                            <MenuItem key={'admin'} value={'admin'}>
                                admin
                            </MenuItem>
                            <MenuItem key={'operativo'} value={'operativo'}>
                                operativo
                            </MenuItem>
                        </TextField>
                    </Col>
                    <Col lg='6' md='6' xs="12">
                        <Autocomplete
                            variant='outlined'
                            required
                            margin="dense"
                            options={listado}
                            key={`key_centro_costos`}
                            id={`select_centro_costos`}
                            onChange={(event, newValue) => setCentroCosto(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} variant='outlined' label='Centro de Costos' margin="normal" />
                            )}
                            getOptionLabel={(option) => option}
                            renderOption={(option) => (
                                <React.Fragment>
                                    {option}
                                </React.Fragment>
                            )}
                        />
                    </Col>
                </Row>
                {tipo === 'operativo' ?
                    <div><Row>
                        <Col lg='12' style={{ marginTop: '5px' }}>
                            <Breadcrumb>
                                <BreadcrumbItem className='BreadcrumbItem-color'>Primer Aprobador</BreadcrumbItem>
                            </Breadcrumb>
                        </Col>
                    </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_1apr_id`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { setCod_1apr(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_1apr_name`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { setCod_1apr_name(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_1apr_email`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { setCod_1apr_email(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_1apr_pos`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { setCod_1apr_cargo(e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Segundo Aprobador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_2apr_id`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { setCod_2apr(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_2apr_name`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { setCod_2apr_name(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_2apr_email`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { setCod_2apr_email(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_2apr_pos`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { setCod_2apr_cargo(e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Tercer Aprobador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_3apr_id`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { setCod_3apr(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_3apr_name`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { setCod_3apr_name(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_3apr_email`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { setCod_3apr_email(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_3apr_pos`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { setCod_3apr_cargo(e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Cuarto Aprobador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_4apr_id`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { setCod_4apr(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_4apr_name`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { setCod_4apr_name(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_4apr_email`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { setCod_4apr_email(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_4apr_pos`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { setCod_4apr_cargo(e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Reclutador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">

                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_recl_id`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { setCod_recl(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_recl_name`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { setCod_recl_name(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_recl_email`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { setCod_recl_email(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_recl_pos`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { setCod_recl_cargo(e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Contratador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_cont_id`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { setCod_cont(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_cont_name`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { setCod_cont_name(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_cont_email`}
                                    id={`input_pass`}
                                    fullWidth
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { setCod_cont_email(e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_cont_pos`}
                                    id={`input_passconf`}
                                    fullWidth
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { setCod_cont_cargo(e.target.value) }}
                                />
                            </Col>
                        </Row>
                    </div> : null}
                <Row>
                    <Col lg='12' md='12' xs="12" className='user-create-button'>
                        <CrearUsuario
                            onClick={() => crearFlujo()}
                            disabled={!getValidacion()} 
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
}
export default connect(mapStateToProps)(BodyCrearFlujo);